import { sva } from '@portal/styled-system/css'

export const navbarChatButton = sva({
    className: 'navbarChatButton',
    slots: ['root', 'unreadBadge'],
    base: {
        root: {
            position: 'relative',
            height: '[26px]',
            border: '[1px solid var(--colors-info)]',
            display: 'flex',
            alignItems: 'center',
            gap: '1',
            paddingInline: '3',
            borderRadius: 'sm',
            fontSize: '[16px]',
            _hover: {
                borderColor: 'info.600',
            },
            _focus: {
                boxShadow: '[0 0 0 0.2rem var(--shadow-color)]',
                boxShadowColor: '[info/25]',
            },
        },
        unreadBadge: {
            position: 'absolute',
            top: '0',
            right: '0',
            width: '3',
            height: '3',
            borderRadius: '[50%]',
            backgroundColor: 'danger',
            border: '[1px solid var(--colors-white)]',
            pointerEvents: 'none',
            transform: 'translate(4px, -4px)',
        },
    },
    variants: {
        isChatOpen: {
            false: {
                root: {
                    color: 'white',
                    backgroundColor: 'info',
                    _hover: {
                        backgroundColor: 'info.600',
                    },
                },
            },
            true: {
                root: {
                    color: 'info',
                    backgroundColor: 'white',
                    _hover: {
                        color: 'info.600',
                    },
                },
            },
        },
    },
})
